import { applyPassiveEventsPatch } from './utils/passiveEventsPatch'
applyPassiveEventsPatch()

import 'mapbox-gl/dist/mapbox-gl.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RecoilRoot } from 'recoil'
import App from './App.jsx'
import './index.css'
import './styles/loading-animations.css'
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>,
)
